import favoritesStore from '../store/store';
import { mutator } from 'satcheljs';
import setFavoritesLoaded from '../actions/setFavoritesLoaded';
import { FolderTreeLoadStateEnum } from 'owa-folders';

export default mutator(setFavoritesLoaded, actionMessage => {
    favoritesStore.favoritesLoaded = true;
    const userIdentity = actionMessage?.userIdentity;
    if (userIdentity && favoritesStore?.favoriteTreeData?.has(userIdentity)) {
        const favoriteTreeDataLoadingState = favoritesStore.favoriteTreeData.get(userIdentity);
        if (favoriteTreeDataLoadingState) {
            favoriteTreeDataLoadingState.loadingState = FolderTreeLoadStateEnum.Loaded;
        }
    }
});
